import { EntityStateModel } from 'app/projects/entity/src/lib/models/entity.state-model';
import { MaxBrainScheduledStreamContent } from './scheduled-stream-content.model';

export class ScheduledStreamContentStateModel extends EntityStateModel<MaxBrainScheduledStreamContent> {}
